// Shared namespace for code-defined skills, independent of any workspace.
export const CODE_DEFINED_SKILLS_WORKSPACE_ID = "global";
export const MAX_SKILL_SEARCH_RESULTS = 100;
